import { connect } from 'react-redux'
import UserProfile from './UserProfile'
import { getBalanceData, getCatalogData } from './selectors'

const mapStateToProps = state => ({
  ...state.oidc.user.profile,
  catalog: getCatalogData(state),
  balance: getBalanceData(state)
})

export default connect(mapStateToProps)(UserProfile)



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfileContainer.js